import { render, staticRenderFns } from "./CoachingScans.vue?vue&type=template&id=63cc5b39&"
import script from "./CoachingScans.vue?vue&type=script&lang=js&"
export * from "./CoachingScans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports